import orderHeader from "../Header/layout.vue";
import card from "@/components/common/card.vue";
import payment from "@/components/modal/payment/layout.vue";
import list from "./list/layout.vue";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import mixinFilter from "@/mixins/mixinFilter";
export default {
  mixins: [mixinFilter],
  metaInfo: {
    title: "주문확인 및 결제"
  },
  components: {
    orderHeader,
    card,
    payment,
    list,
    commonPopup
  },
  data() {
    return {
      isAllCheck: false,
      paymentOpen: false,
      orders: [],
      selectedOrders: [],
      notSelectedOrders: [],
      popupMessage: null,
      popupOpen: false,
      vehicles: null
    };
  },
  watch: {
    filteredSelect() {
      this.selectedOrders = [];
      this.notSelectedOrders = [];

      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].checked === true) {
          this.selectedOrders.push(this.orders[i]);
        }
        if (this.orders[i].checked === false || !this.orders[i].checked) {
          this.notSelectedOrders.push(this.orders[i]);
        }
      }
    },

    selectedOrders() {
      //선택할 오더가 없는 경우 allChecked = false (전체 체크 해제)
      if (this.orders.length === 0 || this.selectedOrders.length === 0) {
        return (this.isAllCheck = false);
      }
      //선택한 오더가 1이상, 전체는 아닌 경우
      const haveSelectedOrders =
        this.selectedOrders.length > 0 &&
        this.selectedOrders.length !== this.orders.length &&
        this.isAllCheck;
      //모든 오더를 선택한 경우
      const isAllselected =
        this.selectedOrders.length === this.orders.length && !this.isAllCheck;
      if (haveSelectedOrders || isAllselected) {
        this.isAllCheck = !this.isAllCheck;
      }
    }
  },
  computed: {
    filteredSelect() {
      return this.orders.map((it) => it.checked);
    }
  },
  async created() {
    this.$store.dispatch("initializeStore");
    const result = await this.$store.dispatch("config/getVehicles");
    this.vehicles = result.vehicle;
    this.orders = _.cloneDeep(this.$store.getters["returnPlacedOrder"]());
    this.orders.length > 0
      ? (this.resetSelected(), (this.isAllCheck = true))
      : (this.isAllCheck = false);
  },
  methods: {
    handlePopup(msg) {
      this.popupMessage = msg;
      this.popupOpen = true;
    },
    handlePaymentModal() {
      if (this.selectedOrders.length <= 0)
        return this.handlePopup("주문을 선택해주세요");
      this.paymentOpen = true;
    },
    changeChecked(idx) {
      this.$set(this.orders[idx], "checked", !this.orders[idx].checked);
    },
    resetSelected() {
      for (let i = 0; i < this.orders.length; i++) {
        this.$set(this.orders[i], "checked", true);
      }
    },
    selectAll() {
      if (this.isAllCheck) {
        this.orders.map((element) => {
          element.checked = false;
        });
        this.selectedOrders = [];
        this.notSelectedOrders = this.orders;
      } else {
        this.orders.map((element) => {
          element.checked = true;
        });
        this.selectedOrders = this.orders;
        this.notSelectedOrders = [];
      }
    },
    moveToForm() {
      this.$router.push("/orders/form");
    },

    deleteEachPlacedOrder(idx) {
      if (this.selectedOrders.length === 0) {
        if (this.orders.length < 1) {
          return;
        }
        return this.handlePopup("주문을 선택해주세요");
      }
      const allow = confirm("선택한 주문을 삭제 하시겠습니까?");
      if (!allow) return;
      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].checked == true) {
          this.orders.splice(i, 1);
          i--;
        }
      }

      this.$store.commit("replaceTemporaryOrders", this.orders);
      this.isAllCheck = false;
    },

    replaceTemporaryOrders() {
      this.$store.commit("replaceTemporaryOrders", this.notSelectedOrders);
    }
  }
};
